/**
 * Blocks storefront analytics & pixels for preview URLs, iframes (editor embed), and ?fs_preview=1.
 */
export function isPreviewPath(pathname: string): boolean {
  return pathname.startsWith("/preview/");
}

export function isInIframe(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export function isTrackingAllowed(pathname?: string): boolean {
  if (typeof window === "undefined") return false;
  const path = pathname ?? window.location.pathname;
  if (isPreviewPath(path)) return false;
  try {
    if (new URLSearchParams(window.location.search).get("fs_preview") === "1") return false;
  } catch {
    /* ignore */
  }
  if (isInIframe()) return false;
  return true;
}
